// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._PK2TUxQopk9br7gSrun{justify-content:space-between;align-items:center;margin-top:16px;display:flex}.kOKmsnLd1L0fmC41AuQN{align-items:center;gap:12px;min-width:0;display:flex}.P1rmm4wV1UMKqh_XaSQZ{background:var(--background-neutral-subtle);border-radius:4px;flex-shrink:0;width:32px;height:32px;overflow:hidden}.GKjO9FMaNIj639c7gOug{object-fit:cover;width:100%;height:100%}.YnG2Ig4TVH4q2ePaeEc6{flex-direction:column;justify-content:center;gap:5px;min-width:0;padding:10px 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `_PK2TUxQopk9br7gSrun`,
	"info": `kOKmsnLd1L0fmC41AuQN`,
	"preview": `P1rmm4wV1UMKqh_XaSQZ`,
	"media": `GKjO9FMaNIj639c7gOug`,
	"meta": `YnG2Ig4TVH4q2ePaeEc6`
};
export default ___CSS_LOADER_EXPORT___;
